import template from './dialog.html';

class ChartDialogViewModel {
	/**
	* ViewModel constructor.
	* @param {ChartDialogClass} dialog - ChartDialogClass class
	*/
	constructor(page) {
		this.page = page;

		//chart id's
		this.chart_id = ko.observable('');
		this.data_source_id = ko.observable();
		this.legend_id = ko.observable(''); 
		this.tooltip_id = ko.observable('');
		this.x_axis_id = ko.observable('');
		this.y_axis_id = ko.observable('');

		//Chart params
		this.data_source_type = ko.observable();
		this.chart_name = ko.observable('');
		this.x_axis_name = ko.observable('');
		this.y_axis_name = ko.observable('');
		this.source_schema = ko.observable();
		this.source_table = ko.observable();
		this.data_source_report = ko.observable('');
		this.report_definition_id = ko.observable();
		this.report_definition_version = ko.observable();
		this.raw_data = ko.observableArray();	

		this.series = ko.observableArray([{
			series_id: ko.observable(''),
			series_name: ko.observable(''),
			x_axis_id: ko.observable(''),
			y_axis_id: ko.observable(''),
			x_axis_field: ko.observable(''),
			y_axis_field: ko.observable(''),
			series_type: ko.observable(''),
			use_x_axis: ko.observable(true),
			color: ko.observable()
		}]);
		
		//Load Schemas and Tables
		this.available_schemas = ko.observableArray([]);
		this.available_columns = ko.observableArray([]);
		this.available_tables = ko.observableArray([]);
		this.available_types = ko.observableArray(["line", "bar", "pie"]);
		this.raw_table_data = ko.observableArray([]);
		
		this.data_source_type.subscribe(async () => {
			await this.get_schemas();
			await this.get_tables();
		});

		this.source_schema.subscribe(schema => {
			let tables = this.raw_table_data().filter(item => item.schema === schema).map(item => item.name);
			this.available_tables([...new Set(tables.map(item => item))]);
		});

		this.source_table.subscribe(async () => {
			await this.get_columns()
		});

		this.data_source_report.subscribe(async () => {
			await this.get_columns();
		});
	}

	async load ()
	{
		this.data_source_type('table');
	}

	async get_schemas ()
	{
		if (this.data_source_type() === 'report')
		{	
			let data = await Grape.fetches.getJSON('/api/record', {schema: 'reports', table: 'v_latest_reports'});

			if (data.status === 'OK' && data.records.length != 0)
			{
				let reports_definitions = data.records.map(rec => {
					return {
						report_definition_id: rec.report_definition_id,
						version: rec.version,
						definition_name: rec.name,
						result_table: rec.result_table,
						params: rec.default_function_criteria
					}
				});
				this.raw_data(reports_definitions);
				this.available_schemas(reports_definitions);

				if (this.chart_id() != '')
				{
					let filter = this.available_schemas().filter(
						item => item.report_definition_id == this.report_definition_id()
					); // Note Use find
					this.data_source_report(filter[0]);
				}
			}
			else
				Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No data. Please ensure you have created a report to process.'});
		}
		else
		{
			let body = {
				schema: 'grape',
				table: 'v_pg_functions',
				filter: [
					{field: 'routine_schema', 'operator': '=', value: 'entity'},
					{field: 'routine_schema', 'operator': '=', value: 'data_export'},
					{field: 'routine_schema', 'operator': '=', value: 'crm'},
					{field: 'routine_schema', 'operator': '=', value: 'sales'},
					{field: 'routine_schema', 'operator': '=', value: 'orders'},
					{field: 'routine_schema', 'operator': '=', value: 'reports'}
				],
				filter_join: 'OR',
				limit: 5000
			}
			let response = await Grape.fetches.getJSON('/api/record', body);
			this.available_schemas([...new Set(response.records.map(item => item.routine_schema))]);
		}
	}

	
	async btnSave_click () {
		let chart = {
			name: this.chart_name(),
		};

		let chart_data = await Grape.fetches.postJSON('/api/echarts/chart/save', {chart});
		if (chart_data.chart_id > 0)
		{
			Grape.alerts.alert({type: 'success', title: 'Success', message: 'Chart Successfully saved'});
			this.page.close(true);
		}


		/*
		let source_obj = {
			schema: this.data_source_type() === 'table' ? this.source_schema() : '',
			table: this.data_source_type() === 'table' ? this.source_table() : '',
			type: this.data_source_type(),
			definition_id: this.data_source_type() === 'table' ? '' : this.data_source_report().report_definition_id,
			version: this.data_source_type() === 'table' ? '' : this.data_source_report().version		
		};

		let data_source = await Grape.fetches.postJSON('/api/echarts/data/source', source_obj);
		if (data_source.status === 'OK')
		{
			this.data_source_id(data_source.data_source_id);
			let chart = {
				name: this.chart_name(),
				legend: {
					legend_id: this.legend_id(),
					type: 'scroll',
					text_style : { color: 'var(--fg-c1)'}
				},
				tooltip: { trigger: 'axis'}
			};

			let series_data = this.series_builder();
			chart = {...chart, ...series_data};//ES6 Spread Operator

			console.log(`dialog save --> ${JSON.stringify(chart)}`)
			//let chart_data = await Grape.fetches.postJSON('/api/echarts/chart/save', {chart});
			if (chart_data.chart_id > 0)
			{
				Grape.alerts.alert({type: 'success', title: 'Success', message: 'Chart Successfully saved'});
				this.page.close(true);
			}
		}
		else
			console.error(data_source);
		*/
	}
	
	series_builder ()
	{
	 	let series_data = ko.toJS(this.series());
		let result = {series: []};
		let colors = ['#3f79ca', '#ffa500', '#90EE90', '#8B5F65', '#DAA520', '#4682B4', '#9ACD32', '#CD853F'];

		for (let i = 0; i < series_data.length; i++) {
			let series = series_data[i];
			let series_object;
			if (series_data.length == 0)
			{
				series_object = {
					series_id: series.series_id,
					name: series.series_name,
					data_source_id: this.data_source_id(),
					type: series.series_type,
					data_source_options: {
						source_field: [series.x_axis_field, series.y_axis_field]
					},
					series_type_options: {
						symbol: 'line', 
						line_style: {
							type: 'solid', 
							width: 3,
							color: colors[i]
						}
					},
					color: colors[i],
				};
			}
			else
			{
				series_object = {
					series_id: series.series_id,
					name: series.series_name,
					data_source_id: this.data_source_id(),
					type: series.series_type,
					data_source_options: {
						source_field: [series.x_axis_field, series.y_axis_field]
					},
					series_type_options: {
						symbol: 'line', 
						line_style: {
							type: 'solid', 
							width: 3,
							color: series.color ?? colors[i]
						}
					},	
					y_axis: {
						axis_id: series.y_axis_id,
						type: 'value',
						name: this.y_axis_name(), 
						name_location: 'middle', 
						name_gap: 50
					},
					color: series.color ?? colors[i]
				};
			};

			if (series.use_x_axis)
			{
				series_object.x_axis = {
					axis_id: series.x_axis_id,
					type: 'category', 
					name: this.x_axis_name(), 
					name_location: 'middle',
					position: 'right',
					name_gap: 50
				}
			}

			if (i == 0) //Set first series y-axis name
				series_object.y_axis.name = 'Value'; 

			result.series.push(series_object);
		}
		return result;
	}

	async get_tables ()
	{
		let response = await Grape.fetches.getJSON('/api/record', {
			schema: 'grape',
			table: 'v_pg_tables',
			limit: 5000,
			fields: ['name', 'schema'],
			filter: [
				{field: 'schema', 'operator': '=', value: 'entity'},
				{field: 'schema', 'operator': '=', value: 'data_export'},
				{field: 'schema', 'operator': '=', value: 'crm'},
				{field: 'schema', 'operator': '=', value: 'orders'},
				{field: 'schema', 'operator': '=', value: 'sales'},
				{field: 'schema', 'operator': '=', value: 'reports'}
			],
			filter_join: 'OR'
		});
		this.raw_table_data(response.records);
	}

	async get_columns ()
	{
		if (this.data_source_type() != 'report')
		{
			let response = await Grape.fetches.getJSON('/api/record', {
				schema: 'grape',
				table: 'v_pg_columns',
				limit: 5000,
				filter: [
					{field: 'schema_name', 'operator': '=', value: this.source_schema()},
					{field: 'table_name', 'operator': '=', value: this.source_table()}
				],
				fields: ['column_name']
			});
			this.available_columns(response.records.map(item => item.column_name));
		}
		else
			this.available_columns(this.data_source_report().params.selected_columns);
	}
	
	btnAdd_series_click ()
	{
		this.series.push({ 
			series_id: ko.observable(''),
			series_name: ko.observable(''),
			x_axis_field: ko.observable(''),
			y_axis_field: ko.observable(''),
			series_type: ko.observable(''),
			use_x_axis: ko.observable(true),
			color: ko.observable()
		});
	}

	btnRemove_series_click (index)
	{
		let series = this.series();
		series.splice(index, 1);
		this.series(series);
	}

	btnClose_click () 
	{
		this.page.close(false);
	}
}

class ChartDialogClass {
	/**
	* constructor
	* @param {Object} bindings -
	*/
	constructor(bindings, element) {
		this.bindings = bindings;
		this.element = element;
		this.viewModel = new ChartDialogViewModel(this);
	}

	async init ()
	{
		await this.viewModel.load();
	}
}

export default {
	name: 'Chart',
	dialog_class: ChartDialogClass,
	template: template,
	provider: 'ps'
};
